import createDataContext from './createDataContext.js'

interface StateType {
    receivePartsDropDown: { coords: { x: number, y: number, width: number, height: number } },
    stockTransferDropDown: { coords: { x: number, y: number, width: number, height: number } },
    entitiesData: any[],
    fromQCToIRData: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string } | null,
    fromIRToQCData: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string } | null,
}

interface ActionType {
    type: string,
    payload: any
}

const initialState: StateType = {
    receivePartsDropDown: { coords: { x: -1, y: -1, width: 0, height: 0 } },
    stockTransferDropDown: { coords: { x: -1, y: -1, width: 0, height: 0 } },
    entitiesData: [],
    fromQCToIRData: null,
    fromIRToQCData: null
}

const reducer = (state: StateType, action: ActionType) => {

    switch(action.type)
    {
        case 'setReceivePartsDropDown': return { ...state, receivePartsDropDown: { coords: action.payload } }

        case 'setStockTransferDropDown': return { ...state, stockTransferDropDown: { coords: action.payload } }

        case 'setEntitiesData': return { ...state, entitiesData: action.payload }

        case 'setQCToIRData': return { ...state, fromQCToIRData: action.payload }

        case 'setIRToQCData': return { ...state, fromIRToQCData: action.payload }

        default: return initialState
    }

}

const setIRToQCData = dispatch => {

    return (data: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string }, callback?: () => void) => {

        dispatch({ type: 'setIRToQCData', payload: data })

        callback?.()

    }

}


const setQCToIRData = dispatch => {

    return (data: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string }, callback?: () => void) => {

        dispatch({ type: 'setQCToIRData', payload: data })

        callback?.()

    }

}

const setEntitiesData = dispatch => {

    return (data, callback?: () => void) => {

        dispatch({ type: 'setEntitiesData', payload: data })
        
        callback && callback?.()
    }

}

const setStockTransferDropDown = dispatch => {

    return (data) => {
        dispatch({ type: 'setStockTransferDropDown', payload: data })
    }

}

const setReceivePartsDropDown = dispatch => {

    return (data) => {
        dispatch({ type: 'setReceivePartsDropDown', payload: data })
    }

}

export interface SparesInterface {
    state: StateType,
    setReceivePartsDropDown: (data: { x: number, y: number, width: number, height: number }) => void,
    setStockTransferDropDown: (data: { x: number, y: number, width: number, height: number }) => void,
    setEntitiesData: (data: [], callback?: () => void) => void,
    setQCToIRData: (data: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string }, callback?: () => void) => void,
    setIRToQCData: (data: { partNumber: string, skuId: string, requestId: string, source: string, currentPage: number, requestItemId: string, search: string, locationFilter: string }, callback?: () => void) => void
}

export const { Context: SparesContext, Provider: SparesProvider } = createDataContext(reducer,
    { setReceivePartsDropDown, setStockTransferDropDown, setEntitiesData, setQCToIRData, setIRToQCData },
    initialState)
